import * as React from "react";
import "../../style/fonts.css";
import "./counterDetail.css";
import CounterDetailElement from "./counterDetailElement";

import overview_awards1x from "../../icons/footage/others/overview_awards.png";
import overview_awards2x from "../../icons/footage/others/overview_awards@2x.png";
import overview_awards3x from "../../icons/footage/others/overview_awards@3x.png";

import overview_challenges1x from "../../icons/footage/others/overview_challenges.png";
import overview_challenges2x from "../../icons/footage/others/overview_challenges@2x.png";
import overview_challenges3x from "../../icons/footage/others/overview_challenges@3x.png";

import overview_high_fives1x from "../../icons/footage/others/overview_high_fives.png";
import overview_high_fives2x from "../../icons/footage/others/overview_high_fives@2x.png";
import overview_high_fives3x from "../../icons/footage/others/overview_high_fives@3x.png";

import overview_stars1x from "../../icons/footage/others/overview_stars.png";
import overview_stars2x from "../../icons/footage/others/overview_stars@2x.png";
import overview_stars3x from "../../icons/footage/others/overview_stars@3x.png";

import overview_supporter1x from "../../icons/footage/others/overview_supporter.png";
import overview_supporter2x from "../../icons/footage/others/overview_supporter@2x.png";
import overview_supporter3x from "../../icons/footage/others/overview_supporter@3x.png";

import overview_supporting1x from "../../icons/footage/others/overview_supporting.png";
import overview_supporting2x from "../../icons/footage/others/overview_supporting@2x.png";
import overview_supporting3x from "../../icons/footage/others/overview_supporting@3x.png";
import translate from "../../translations/i18n";
import ProfileData from "src/interfaces/models/profileData";

export interface Props {
  profile: ProfileData;
  stars: number;
  highfiveNo: number;
  badges: any;
  total_challenges: number;
  supporters: number;
  support_others: number;
  style?: any;
}

class CounterDetail extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }

  render() {
    let awards = 0;
    if (this.props.badges) {
      awards = this.props.badges
        .filter(badge => {
          return badge.state != 0;
        })
        .length.toString();
    }
    if (this.props.profile && this.props.stars != undefined) {
      return (
        <div>
        <div className="COUNTER_DETAIL_CONT">
          
          <CounterDetailElement
            icon1x={overview_stars1x}
            icon2x={overview_stars2x}
            icon3x={overview_stars3x}
            num={this.props.stars}
            title={translate("STARS")}
          />
          <CounterDetailElement
            icon1x={overview_awards1x}
            icon2x={overview_awards2x}
            icon3x={overview_awards3x}
            num={awards}
            title={translate("AWARDS")}
          />
          </div>
          <div className="COUNTER_DETAIL_CONT">
          <CounterDetailElement
            icon1x={overview_high_fives1x}
            icon2x={overview_high_fives2x}
            icon3x={overview_high_fives3x}
            num={this.props.highfiveNo}
            title={translate("HIGHFIVES")}
          />
          <CounterDetailElement
            icon1x={overview_supporter1x}
            icon2x={overview_supporter2x}
            icon3x={overview_supporter3x}
            num={this.props.supporters}
            title={translate("SUPPORTERS")}
          />
          <CounterDetailElement
            icon1x={overview_supporting1x}
            icon2x={overview_supporting2x}
            icon3x={overview_supporting3x}
            num={this.props.support_others}
            title={translate("SUPPORT_OTHERS")}
          />
        </div>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

export default CounterDetail;



// WEBPACK FOOTER //
// ./src/components/counterDetail/counterDetail.tsx